import { GridConfig } from '@alejandro.devop/bootstrap-smart-grid'
import workflows from '@locales/es/workflows.json'
import WorkflowMapIds from '@constants/workflows-map'
import endpointDefinitions from '@definitions/endpoints.def.json'

const config: GridConfig<keyof typeof endpointDefinitions> = {
    loadingLabel: 'Loading trikos',
    allowSelect: true,
    debug: false,
    id: 'trikos-grid',
    url: 'trikos.registered',
    columnVisibility: {
        id: true,
        phonenumber: true,
        email: true,
        identification: true,
        firstName: true,
        lastName: true,
        country: false,
        city: true,
        state: true
    },
    defaultFilters: {
        region: 1
    },
    displayFiltersFormatter: (filters: { label: string; value: any }[]) => {
        return filters.map((filter) => {
            if (filter.label === 'workflow_transition') {
                filter.value = WorkflowMapIds[filter.value]
            }
            return filter
        })
    },
    fields: {
        id: { label: 'ID', value: ({ id }: { id: number }) => `${id}` },
        phonenumber: {
            label: 'phoneNumber',
            value: 'attributes.user.phonenumber',
            sort: true,
            filter: true,
            filterOptions: {
                name: 'phonenumber'
            }
        },
        email: {
            label: 'email',
            value: 'attributes.user.email',
            sort: true,
            filter: true
        },
        identification: {
            label: 'phoneNumber',
            value: 'attributes.personalInformation.idnumber',
            sort: true,
            filter: true,
            filterOptions: {
                name: 'idnumber'
            }
        },
        firstName: {
            label: 'firstName',
            value: 'attributes.personalInformation.firstname',
            filter: true,
            filterOptions: {
                name: 'first_name'
            }
        },
        lastName: {
            label: 'lastName',
            value: 'attributes.personalInformation.lastname',
            filter: true,
            filterOptions: {
                name: 'last_name'
            }
        },
        country: {
            label: 'country',
            value: 'attributes.location.country'
        },
        city: {
            label: 'city',
            value: 'attributes.location.city',
            sort: true,
            filter: true,
            filterOptions: {
                name: 'city',
                type: 'select',
                selectOptions: {
                    ajax: true,
                    url: 'settings.cities',
                    advanced: true,
                    columnsMapping: {
                        label: 'name',
                        value: 'id'
                    },
                    requestConfig: {
                        filters: {
                            country_id: 48
                        }
                    }
                }
            }
        },
        state: {
            label: 'status',
            value: (rowData: { attributes: { workflow: { workflow: string } } }) => {
                return workflows[rowData.attributes.workflow.workflow]
            },
            sort: true,
            filter: true,
            filterOptions: {
                name: 'workflow_transition',
                type: 'select',
                preProcessFilterValue: (value) => `${value}`,
                selectOptions: {
                    ajax: true,
                    url: 'settings.workflowTransitions',
                    advanced: true,
                    columnsMapping: {
                        label: 'workflow',
                        value: 'id',
                        labelProcessor: (label: string) => workflows[label] || label
                    },
                    requestConfig: {
                        filters: {
                            workflow_transition_type_id: '1'
                        }
                    }
                }
            }
        },
        service: {
            label: 'service',
            filter: true,
            notReadable: true,
            value: () => '',
            filterOptions: {
                name: 'service',
                type: 'select',
                preProcessFilterValue: (value) => `[${value}]`,
                selectOptions: {
                    ajax: true,
                    url: 'services.list',
                    advanced: true,
                    columnsMapping: {
                        label: 'name',
                        value: 'id',
                        labelProcessor: (data: any) => {
                            return data.es
                        }
                    }
                }
            }
        }
    },
    actions: [{ icon: 'eye', id: 'view', label: 'view' }],
    headers: {
        id: { label: 'ID', value: ({ id }: { id: number }) => `${id}` }
    }
}

export default config
